let mutations = {
  UPDATE_TOKEN (state, data) {
    state.token = data
  },
  SET_USER_ID (state, data) {
    state.contactId = data
  },
  SET_LOADING (state, data) {
    state.isLoading = data
  },
  SET_DETAIL_LOADING (state, data) {
    state.isDetailLoading = data
  },
  SET_MESSAGE_LOADING (state, data) {
    state.isMessageLoading = data
  },
  SET_QUESTION_DETAIL (state, data) {
    state.questionDetail = data
  },
  SET_MESSAGE_DETAIL (state, data) {
    state.messageDetail = data
  },
  SET_RELATED_QUIZ_DETAIL (state, data) {
    state.relatedQuizDetail = data
  },
  SET_QUESTION_PAGE (state, data) {
    state.questionPage = data
  },
  SET_ALL_QUESTION_COUNT (state, data) {
    state.allQuestionCount = data
  },
  SET_PAGE_COUNT (state, data) {
    state.pageCount = data
  },
  SET_RED_POINT (state, data) {
    state.redPoint = data
  },
  SET_RED_POINT_TIME (state, data) {
    state.redPointTime = data
  },
  setImgForPreview (state, data) {
    for (let key of Object.keys(data)) {
      state.previewImg[key] = data[key]
    }
  },
  //传递视频资源路径给ali播放器显示
  SET_VIDEO_DIALOG  (state, payload) {
    state.aliPlayerUrl = payload
  }
}

export default mutations



// WEBPACK FOOTER //
// ./src/vuex/mutations.js